import PropTypes from 'prop-types';
import {
	compose,
	getContext,
	withProps
} from 'recompose';
import { isExtraLarge } from 'utils/breakpoints';

import CustomOverlayComponent from './customOverlayComponent';

export const enhance = compose(
	getContext({
		disableIdleEvent: PropTypes.func
	}),
	withProps((props) => ({
		animationDelay: 250,
		className: 'info-window',
		appendToMap: !isExtraLarge(props.viewportWidth),
		gesturesDisabled: !isExtraLarge(props.viewportWidth)
	}))
);

export default enhance(CustomOverlayComponent);
